import type * as React from 'react';

function SvgArrowForwardCircle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M10.7803 7.2197C10.4873 6.9267 10.0126 6.9267 9.71975 7.2197C9.42685 7.5127 9.42675 7.9873 9.71975 8.2802L13.4394 11.9999L9.71975 15.7196C9.42675 16.0126 9.42675 16.4872 9.71975 16.7801C9.86625 16.9266 10.0577 16.9998 10.2501 16.9998C10.4425 16.9998 10.6339 16.9266 10.7804 16.7801L15.0303 12.5301C15.3233 12.2371 15.3233 11.7625 15.0303 11.4696L10.7803 7.2197Z"
        fill="currentColor"
      />
      <path
        d="M12 2C6.4863 2 2 6.4858 2 12C2 17.5142 6.4863 22 12 22C17.5137 22 22 17.5142 22 12C22 6.4858 17.5137 2 12 2ZM12 20C7.5889 20 4 16.4111 4 12C4 7.5889 7.5889 4 12 4C16.4111 4 20 7.5889 20 12C20 16.4111 16.4111 20 12 20Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgArrowForwardCircle;
